import { render, staticRenderFns } from "./VelorioOnline.vue?vue&type=template&id=5a53044a"
import script from "./VelorioOnline.vue?vue&type=script&lang=js"
export * from "./VelorioOnline.vue?vue&type=script&lang=js"
import style0 from "./VelorioOnline.vue?vue&type=style&index=0&id=5a53044a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports